import React, { Component } from "react";
import { GET, loading } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo-landscape.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
    };
  }

  async componentDidMount() {
    loading(false);
    const token = window.location.pathname.replace("/verify/", "");
    const result = await GET("v1/public/verify-email", { token: token });
    if (result?.status) {
      this.setState({ status: "success" });
    } else {
      this.setState({ status: "error" });
    }
  }

  render() {
    const { status } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pp-scope">
        <div className="row mx-0">
          <div className="col-11 col-sm-8 col-md-6 col-xl-5 col-xxl-4 py-4 mx-auto">
            <div className="ar-hero mb-4">
              <img
                alt="logo"
                src={LOGO}
                height={34}
                style={{ objectFit: "contain" }}
                className="mb-3"
              />
              <div className="ar-eyebrow mb-1">Account</div>
            </div>
            {status === "success" && (
              <div className="rounded-4 bg-white shadow-sm p-4 text-center">
                <span className="icon text-success text-72 mb-3">
                  {"\uf058"}
                </span>
                <h3 className="fw-bold mb-3">Email Verification</h3>
                <hr />
                <span>
                  Your email was verified. You can continue using the
                  applicatin.
                </span>
                <br />
                <button
                  className="btn ar-btn-gold justify-content-center mt-3 mb-3"
                  onClick={() => (window.location.href = "/")}
                >
                  Return to Home Page
                </button>
              </div>
            )}
            {status === "error" && (
              <div className="rounded-4 bg-white shadow-sm p-4 text-center">
                <span className="icon text-warning text-72 mb-3">
                  {"\uf06a"}
                </span>
                <h3 className="fw-bold mb-3">
                  Email Verification link expired
                </h3>
                <hr />
                <span>
                  Looks like the verification link has expired. Not to worry,we
                  can send the link again.
                </span>
                <br />
                <button
                  className="btn ar-btn-gold justify-content-center mt-3 mb-2"
                  onClick={() => (window.location.href = "/")}
                >
                  Resend verification link
                </button>
                <br />
                <button
                  className="btn btn-link text-dark mb-3"
                  onClick={() => (window.location.href = "/")}
                >
                  Return to Home Page
                </button>
              </div>
            )}
            {status === "not_found" && (
              <div className="center w-100 min-vh-100 d-flex justify-content-center align-items-center">
                <div className="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-8 col-xxl-6 mx-auto">
                  <div className="p-5 text-center">
                    <h1 className="fw-bold mb-4 text-72">404</h1>
                    <h3 className="mb-4">
                      ขออภัย ไม่พบหน้าเว็บไซต์ที่คุณต้องการ
                    </h3>
                    <button
                      type="button"
                      className="btn ar-btn-gold justify-content-center wpx-200 mt-3 mx-auto"
                      onClick={() => {
                        window.location.href = "/";
                      }}
                    >
                      กลับไปสู่หน้าหลัก
                    </button>
                    <div class="w-100 text-center mt-4">
                      <small class="text-secondary">
                        เวอร์ชั่น {global.version}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
